import { TeiaSearchFilter } from '@stereograph/teia-system-design/utils';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

export interface TeiaQuantityTakeoffContextProps {
  searchRules: TeiaSearchFilter;
  updateSearchRules: (searchRules: TeiaSearchFilter) => void;
}

const TeiaQuantityTakeoffContext = createContext<TeiaQuantityTakeoffContextProps | null>(null);

export interface TeiaQuantityTakeoffWidgetProviderProps {
  children: ReactNode;
  searchRules: TeiaSearchFilter;
}

export const TeiaQuantityTakeoffWidgetProvider = (
  props: TeiaQuantityTakeoffWidgetProviderProps,
) => {
  const { children, searchRules } = props;
  const [currentSearchRules, setCurrentSearchRules] = useState<TeiaSearchFilter>(searchRules);
  const value = useMemo(
    () => ({
      searchRules: currentSearchRules,
      updateSearchRules: (searchRules: TeiaSearchFilter) => setCurrentSearchRules(searchRules),
    }),
    [currentSearchRules, setCurrentSearchRules],
  );

  return (
    <TeiaQuantityTakeoffContext.Provider value={value}>
      {children}
    </TeiaQuantityTakeoffContext.Provider>
  );
};

export const useTeiaQuantityTakeoffContext = () => {
  const context = useContext(TeiaQuantityTakeoffContext);
  if (context === null) {
    throw new Error(
      'useTeiaQuantityTakeoffContext must be used within a TeiaQuantityTakeoffWidgetProvider',
    );
  }

  return context;
};
